export default __webpack_public_path__ + "static/Latency-f4e3eeed518d2c81f714fa2d8f9bb59e.svg";